var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMission = function SvgMission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 301.055 301.055"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.798 31.551c0-4.143-3.357-7.5-7.5-7.5h-79.453a7.5 7.5 0 0 0-7.5 7.5v47.687c0 4.143 3.357 7.5 7.5 7.5h71.953v21.186L102.845 179.9l-18.532-18.54a7.5 7.5 0 0 0-11.463 1.021L1.342 265.221a7.5 7.5 0 0 0-.488 7.755 7.5 7.5 0 0 0 6.647 4.026h286.055c4.143 0 7.5-3.357 7.5-7.5a7.47 7.47 0 0 0-1.661-4.708L189.798 108.66zm-79.453 40.187V39.051h64.453v32.687zM21.85 262.003l58.195-83.694 17.495 17.503a7.506 7.506 0 0 0 10.609 0l73.141-73.165 97.818 139.357z"
  })));
};
export default SvgMission;